import { IUser } from '@wix/native-components-infra/dist/src/types/types';
import { UserData } from '../types/common';

export function getUserData(user: IUser): UserData {
  const { id, instance, role, loggedIn } = user;
  return { id, instance, role, loggedIn };
}
